// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* phoneDialog.css */

.phone-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Optional: to darken the background */
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px); /* Blur effect */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .phone-dialog {
    background-color: #ffffff;
    padding: 40px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 500px;
  }
  
  .phone-dialog-content {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
  }
  
  .phone-input {
    flex: 1 1;
    padding: 10px 50px 10px 20px;
    font-size: 16px;
    border: 1px solid #cacfd8;
    border-radius: 8px;
    outline: none;
    width: 100%;
  }
  
  .phone-input:focus {
    box-shadow: 0 0 10px rgba(93, 43, 133, 0.5) !important;
  }
  
  .input-group-append {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }
  
  .send-button {
    background-color: transparent; /* Set background to transparent */
    border: none;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  
  .send-icon {
    width: 24px;
    height: 24px;
    color: #5D2B85;
  }
  
  .send-button:hover .send-icon {
    animation: shake 0.5s;
  }
  
  @keyframes shake {
    0% { transform: translate(1px, 1px) rotate(0deg); }
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(3px, 2px) rotate(0deg); }
    40% { transform: translate(1px, -1px) rotate(1deg); }
    50% { transform: translate(-1px, 2px) rotate(-1deg); }
    60% { transform: translate(-3px, 1px) rotate(0deg); }
    70% { transform: translate(3px, 1px) rotate(-1deg); }
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(1px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
  }
  
  .error-message {
    color: #4910aa;
    margin-top: 10px;
    font-size: 14px;
  }
  
  /* Add this to your main CSS file or a specific CSS file that gets loaded on all pages */
  
  .blur-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    z-index: 999; /* Make sure it's below the modal */
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Optional: to darken the background */
    z-index: 1000; /* Make sure it's on top of other elements */
  }
  `, "",{"version":3,"sources":["webpack://./src/Taxcal/phonedialog.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,uCAAuC;IACvE,kCAA0B;YAA1B,0BAA0B,EAAE,gBAAgB;IAC5C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,wCAAwC;IACxC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,6BAA6B,EAAE,kCAAkC;IACjE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,KAAK,2CAA2C,EAAE;IAClD,MAAM,8CAA8C,EAAE;IACtD,MAAM,4CAA4C,EAAE;IACpD,MAAM,2CAA2C,EAAE;IACnD,MAAM,4CAA4C,EAAE;IACpD,MAAM,6CAA6C,EAAE;IACrD,MAAM,4CAA4C,EAAE;IACpD,MAAM,4CAA4C,EAAE;IACpD,MAAM,6CAA6C,EAAE;IACrD,MAAM,2CAA2C,EAAE;IACnD,OAAO,6CAA6C,EAAE;EACxD;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA,wFAAwF;;EAExF;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kCAA0B;YAA1B,0BAA0B;IAC1B,YAAY,EAAE,mCAAmC;EACnD;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,uCAAuC;IACvE,aAAa,EAAE,4CAA4C;EAC7D","sourcesContent":["/* phoneDialog.css */\n\n.phone-dialog-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Optional: to darken the background */\n    backdrop-filter: blur(5px); /* Blur effect */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .phone-dialog {\n    background-color: #ffffff;\n    padding: 40px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    width: 500px;\n  }\n  \n  .phone-dialog-content {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    position: relative;\n  }\n  \n  .phone-input {\n    flex: 1;\n    padding: 10px 50px 10px 20px;\n    font-size: 16px;\n    border: 1px solid #cacfd8;\n    border-radius: 8px;\n    outline: none;\n    width: 100%;\n  }\n  \n  .phone-input:focus {\n    box-shadow: 0 0 10px rgba(93, 43, 133, 0.5) !important;\n  }\n  \n  .input-group-append {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    padding: 0 10px;\n  }\n  \n  .send-button {\n    background-color: transparent; /* Set background to transparent */\n    border: none;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n  }\n  \n  .send-icon {\n    width: 24px;\n    height: 24px;\n    color: #5D2B85;\n  }\n  \n  .send-button:hover .send-icon {\n    animation: shake 0.5s;\n  }\n  \n  @keyframes shake {\n    0% { transform: translate(1px, 1px) rotate(0deg); }\n    10% { transform: translate(-1px, -2px) rotate(-1deg); }\n    20% { transform: translate(-3px, 0px) rotate(1deg); }\n    30% { transform: translate(3px, 2px) rotate(0deg); }\n    40% { transform: translate(1px, -1px) rotate(1deg); }\n    50% { transform: translate(-1px, 2px) rotate(-1deg); }\n    60% { transform: translate(-3px, 1px) rotate(0deg); }\n    70% { transform: translate(3px, 1px) rotate(-1deg); }\n    80% { transform: translate(-1px, -1px) rotate(1deg); }\n    90% { transform: translate(1px, 2px) rotate(0deg); }\n    100% { transform: translate(1px, -2px) rotate(-1deg); }\n  }\n  \n  .error-message {\n    color: #4910aa;\n    margin-top: 10px;\n    font-size: 14px;\n  }\n  \n  /* Add this to your main CSS file or a specific CSS file that gets loaded on all pages */\n  \n  .blur-background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    backdrop-filter: blur(5px);\n    z-index: 999; /* Make sure it's below the modal */\n  }\n  \n  .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Optional: to darken the background */\n    z-index: 1000; /* Make sure it's on top of other elements */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
